import { DEFAULT_LANGUAGE, SITE_NAME } from '../config/constants';

export function getLanguageByPath(path: string, fallback = DEFAULT_LANGUAGE) {
  return /^\/[a-z]{2}(\/.*)?$/g.test(path)
    ? path.replace(/^\/([a-z]{2})(\/.*)?/, '$1')
    : fallback;
}

export function getDocumentTitle(title: string) {
  if (!title) {
    return SITE_NAME;
  }

  return `${title} | ${SITE_NAME}`;
}

export function isDateBeforeToday(date: Date) {
  // Initialize today at midnight
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return today.getTime() > date.getTime();
}

export function dateFormatter(date: Date | string, lang = 'nl') {
  const asJsDate = new Date(date);

  return new Intl.DateTimeFormat(lang, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(asJsDate);
}
